import TableContainer from "components/Common/TableContainer"
import moment from "moment"
import React, { useEffect, useMemo, useRef, useState } from "react"
import toast from "react-hot-toast"
import { Button, Toast, ToastBody, UncontrolledTooltip } from "reactstrap"
import CreateSignersModal from "./createSignersModal"
import {
  useDeleteSignersMutation,
  useLazyGetSignersListQuery,
} from "store/api/signers/signers.api"
import edit from "../../assets/images/icons/edit.svg"
import deleteIcon from "../../assets/images/icons/delete-red.svg"
import DeleteConfirmationModal from "modals/deleteConfirmation"

const defaultFilters = {
  search: "",
  page: 1,
  pageSize: 20,
  timestamp: "",
}

const SignerTable = () => {
  const [getResults, { isFetching }] = useLazyGetSignersListQuery()
  const [open, setOpen] = useState(false)
  const [onDelete, { isLoading }] = useDeleteSignersMutation()
  const [data, setData] = useState([])
  const [isToast, setIsToast] = useState(false)
  const deleteRef = useRef(null)
  const [editDetails, setEditdetails] = useState(null)
  const [filters, setFilters] = useState(defaultFilters)
  //meta title
  document.title = "Signatory"

  const getList = async () => {
    try {
      const { data } = await getResults().unwrap()
      setData(data?.rows)
    } catch (e) {}
  }

  useEffect(() => {
    getList()
  }, [filters])

  const onCreateSuccess = () => {
    setFilters((prev) => ({ ...prev, page: 1, timestamp: moment().unix() }))
  }

  const onHandleCreateSigner = () => {
    setOpen(true)
    setEditdetails(null)
  }

  const onActionSuccess = () => {
    setIsToast(false)
    deleteRef.current = null
    setFilters((prev) => ({ ...prev, page: 1, timestamp: moment().unix() }))
  }

  const columns = useMemo(
    () => [
      {
        header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Designation",
        accessorKey: "designation",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Phone No",
        accessorKey: "phone_no",
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        id: "actions",
        header: "Actions",
        cell: ({ row }) => {
          const editTooltip = `editTooltip-${row?.original.id}`
          const deleteTooltip = `deleteTooltip-${row?.original.id}`

          return (
            <div className="d-flex justify-content-center align-items-center gap-3">
              <div
                className="action-view"
                onClick={() => {
                  setEditdetails(row.original)
                  setOpen(true)
                }}
              >
                <img src={edit} id={editTooltip} alt="" />
                <UncontrolledTooltip placement="top" target={editTooltip}>
                  Edit
                </UncontrolledTooltip>
              </div>

              <div
                className="action-delete"
                onClick={() => {
                  deleteRef.current = row?.original
                  setIsToast(true)
                }}
              >
                <img src={deleteIcon} id={deleteTooltip} alt="" />
                <UncontrolledTooltip placement="top" target={deleteTooltip}>
                  Delete
                </UncontrolledTooltip>
              </div>
            </div>
          )
        },
      },
    ],
    []
  )

  const FilterComponents = () => (
    <>
      <Button
        className="btn btn-primary"
        onClick={() => onHandleCreateSigner()}
      >
        Add Signatory
      </Button>
    </>
  )

  return (
    <>
      <TableContainer
        isLoading={isFetching}
        filters={filters}
        isCustomPageSize
        setFilters={setFilters}
        columns={columns}
        data={data}
        FilterComponents={FilterComponents}
        isPagination={true}
        pagination="pagination"
        paginationWrapper="dataTables_paginate paging_simple_numbers"
        tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
      />
      {open && (
        <CreateSignersModal
          open={open}
          title={!editDetails ? "Create" : "Edit"}
          setOpen={setOpen}
          onCreateSuccess={onCreateSuccess}
          editData={editDetails}
        />
      )}

      {isToast && deleteRef && (
        <DeleteConfirmationModal
          open={isToast}
          id={deleteRef.current.id}
          setOpen={setIsToast}
          isLoading={isLoading}
          onClose={() => {
            setIsToast(false)
            deleteRef.current = null
          }}
          title={"Delete Signatory"}
          description="Are you sure you want to delete this signatory?"
          onDelete={onDelete}
          onSuccess={onActionSuccess}
        />
      )}
    </>
  )
}

export default SignerTable
